import { AnyAction } from 'redux';

export enum ModalActionTypes {
  IS_AUTH_OPEN = 'IS_AUTH_OPEN',
  IS_USER_OPEN = 'IS_USER_OPEN',
  MODAL_TYPE = 'MODAL_TYPE',
}

export interface OpenModalAction extends AnyAction {
  type: ModalActionTypes
  payload: boolean;
}

export interface SetModalTypeAction extends AnyAction {
  type: ModalActionTypes.MODAL_TYPE;
  payload: string;
}

export type ModalActionInterface = OpenModalAction | SetModalTypeAction;

export function authModalAction(isAuthModalOpen: boolean): OpenModalAction {
  return {
    type: ModalActionTypes.IS_AUTH_OPEN,
    payload: isAuthModalOpen,
  };
}

export function userModalAction(isUserModalOpen: boolean): OpenModalAction {
  return {
    type: ModalActionTypes.IS_USER_OPEN,
      payload: isUserModalOpen,
    };
}

export function setModalType(modalType: string): SetModalTypeAction {
  return {
    type: ModalActionTypes.MODAL_TYPE,
    payload: modalType,
  };
}
